var map = {
	"./de/mecha-btn.png": "HQah",
	"./en/mecha-btn.png": "3+c+",
	"./es/mecha-btn.png": "L/BU",
	"./fr/mecha-btn.png": "ln9A",
	"./ja/mecha-btn.png": "8jUS",
	"./ko/mecha-btn.png": "Xe9D",
	"./pt/mecha-btn.png": "yIon",
	"./ru/mecha-btn.png": "cjZN",
	"./tc/mecha-btn.png": "0bjB",
	"./th/mecha-btn.png": "Rx1J"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zVOy";